import { render, staticRenderFns } from "./studentListBj.vue?vue&type=template&id=428e5060&scoped=true"
import script from "./studentListBj.vue?vue&type=script&lang=js"
export * from "./studentListBj.vue?vue&type=script&lang=js"
import style0 from "./studentListBj.vue?vue&type=style&index=0&id=428e5060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e5060",
  null
  
)

export default component.exports